import { render, staticRenderFns } from "./TextBlock.vue?vue&type=template&id=487d3dba&"
import script from "./TextBlock.js?vue&type=script&lang=js&"
export * from "./TextBlock.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports